import {
  UPDATE_PVS_REQUEST,
  UPDATE_PVS_SUCCESS,
  UPDATE_PVS_FAILURE,
  RESET_UPDATE_PVS_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const updatePvsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PVS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case UPDATE_PVS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message,
      };

    case UPDATE_PVS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message,
      };

    case RESET_UPDATE_PVS_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default updatePvsReducer;
